import {generateApiEndpoint} from "@api/ApiUtils";
import {getRequest, patchRequest, postRequest} from "@api/ApiService";
import {FORM_TYPE, FormFieldsConfiguration, FormPayload} from "@lib/Form/FormModels";
import {API_MODULES, API_ROUTES, API_SOLUTIONS} from "@api/ApiRoutes";
import {FinalizationResponse, User, ValidateVatRequest, ValidateVatResponse} from "@lib/User/UserModels";

const ROUTES = {
    GET_USER: {
        path: API_ROUTES.GET_USER,
        module: API_MODULES.CORE_USER,
        solution: API_SOLUTIONS.MZ
    },
    PATCH_USER: {
        path: API_ROUTES.PATCH_USER,
        module: API_MODULES.CORE_USER,
        solution: API_SOLUTIONS.MZ
    },
    POST_SSO: {
        path: API_ROUTES.POST_SSO,
        module: API_MODULES.CORE_USER,
        solution: API_SOLUTIONS.MZ
    },
    GET_SSO_FINALIZATION_FORM: {
        path: API_ROUTES.GET_SSO_FINALIZATION_FORM,
        module: API_MODULES.CORE_USER,
        solution: API_SOLUTIONS.MZ
    },
    POST_SSO_FINALIZATION: {
        path: API_ROUTES.POST_SSO_FINALIZATION,
        module: API_MODULES.CORE_USER,
        solution: API_SOLUTIONS.MZ
    },
    VALIDATE_VAT: {
        path: API_ROUTES.VALIDATE_VAT,
        module: API_MODULES.EXT,
        solution: API_SOLUTIONS.MZ
    },
}

class UserService {

    static validateVat = async (vatNumber: string, token?: string | null): Promise<ValidateVatResponse> => {

        const requestHeaders = {
            headers: {
                "x-jak-test": vatNumber.startsWith("jktest") ? "true" : "false",
                Authorization: !!token ? `Bearer ${token}` : undefined,
            }
        }

        const url = generateApiEndpoint(ROUTES.VALIDATE_VAT);

        const payload: ValidateVatRequest = {piva: vatNumber};

        return await postRequest<ValidateVatResponse, ValidateVatRequest>(url, payload, {headers: requestHeaders.headers ?? undefined});

    }

    static getUser = async (token?: string | null): Promise<User> => {

        const requestConfig = token
            ? {headers: {Authorization: `Bearer ${token}`}}
            : undefined;

        const url = generateApiEndpoint(ROUTES.GET_USER);

        return await getRequest<User>(url, requestConfig);
    }

    static finalizeSso = async (payload: FormPayload): Promise<FinalizationResponse> => {
        const url = generateApiEndpoint(ROUTES.POST_SSO_FINALIZATION);

        return await patchRequest<FinalizationResponse, FormPayload>(url, payload);
    }


    /**
     * Form configurations
     */
    public static getForm = async (formType: FORM_TYPE): Promise<FormFieldsConfiguration | void> => {

        switch (formType) {

            case FORM_TYPE.SSO_FINALIZATION: {
                return this.getSsoFinalizationForm();
            }

        }

        return;

    }

    static getSsoFinalizationForm = async (): Promise<FormFieldsConfiguration> => {
        const url = generateApiEndpoint(ROUTES.GET_SSO_FINALIZATION_FORM);

        return await getRequest<FormFieldsConfiguration>(url);
    }

}

export default UserService;